angular
  .module('fca-used')
  .factory('httpInterceptor', ["$q", "$rootScope", "asyncTasks", "CONFIG", "$sce", function ($q, $rootScope, asyncTasks, CONFIG ,$sce) {
    function doShowLoader(config) {
      if(angular.isDefined(config) && angular.isDefined(config.url)){
        return (angular.isString(config.url) && config.url.substr(0, CONFIG.uvl.api.length) === CONFIG.uvl.api) || angular.isString($sce.valueOf(config.url));
      }
      return false
    }
    return {
      request: function (config) {
        if (doShowLoader(config)) {
          asyncTasks.push();
        }
        return config || $q.when(config);
      },
      response: function (response) {
        if (doShowLoader(response.config)) {
          if (response.data && response.data.errors) {
            asyncTasks.error = '500';
          }
          asyncTasks.pop();
        }
        return response || $q.when(response);
      },
      responseError: function (response) {
        if (response.status > 299 &&
          (!CONFIG.mynumber || response.config.url !== CONFIG.mynumber.endpoint) &&
            response.config.url.toLowerCase().indexOf('.jpg') !== response.config.url.length - 4 &&
            response.config.url.toLowerCase().indexOf('.png') !== response.config.url.length - 4 &&
            response.config.url.toLowerCase().indexOf('.jpeg') !== response.config.url.length - 5
           ) {
          if (response.config.url.toLowerCase().indexOf('l10n') === -1) {
            asyncTasks.error = response.status;
          }
        }
        if (doShowLoader(response.config)) {
          asyncTasks.pop();
        }
        return $q.reject(response);
      }
    };
  }])
  .config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
  }]);
